import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/content";

export default function Testimonials() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
          读者口碑 · VOICES
        </p>
        <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          他们说：不再云里雾里
        </h2>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex items-center gap-0.5 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
              ))}
            </div>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-800">
                {t.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground-900">{t.name}</span>
                <span className="block text-xs text-foreground-500">{t.tag}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>

      <p className="mt-6 text-center text-xs text-foreground-500">
        想分享你的围观体验？欢迎到
        <Link to="/about" className="mx-1 font-medium text-primary-700 hover:text-primary-800">
          关于我们
        </Link>
        联系我们。
      </p>
    </section>
  );
}